export default "__VITE_ASSET__4f8d49d5__"